<template>
	<header class="ly_header" :class="{ login: type === 'C' }">
		<!-- A layout  -->
		<div v-if="type === 'A'" class="main wrap">
			<header-logo :onLogoClick="onHomeButtonClick" />
			<span class="btn_area">
				<button type="button" class="btn" @click="$emit('searchButtonClick')">
					<i class="ico24_search"></i>
					<span class="txt_hidden">검색</span>
				</button>
				<router-link to="/orderSend/cartSend" tag="button" type="button" class="btn">
					<i class="ico24_cart"></i>
					<span class="txt_hidden">장바구니</span>
					<em class="badge" v-if="badge">{{ badge }}</em>
				</router-link>
			</span>
		</div>

		<!-- B layout -->
		<div v-if="type === 'B'" class="sub wrap">
			<span class="tit_area">
				<button type="button" @click="goBack()" class="btn">
					<i class="ico24_back"></i>
					<span class="txt_hidden">뒤로가기</span>
				</button>
				<h1>{{ headerTitle }}</h1>
			</span>
			<!-- <span class="btn_area">
        <router-link to="/home" class="btn" @click.native="onHomeButtonClick">
          <i class="ico24_home"></i>
          <span class="txt_hidden">홈</span>
        </router-link>
        <button type="button" class="btn" @click="$emit('searchButtonClick')">
          <i class="ico24_search"></i>
          <span class="txt_hidden">검색</span>
        </button>
      </span> -->
			<span class="btn_area">
				<button type="button" class="btn" @click="$emit('searchButtonClick')">
					<i class="ico24_search"></i>
					<span class="txt_hidden">검색</span>
				</button>
				<router-link to="/orderSend/cartSend" tag="button" type="button" class="btn">
					<i class="ico24_cart"></i>
					<span class="txt_hidden">장바구니</span>
					<em class="badge" v-if="badge">{{ badge }}</em>
				</router-link>
			</span>
		</div>

		<!--- C Layout back button only -->
		<div v-if="type === 'C'" class="sub wrap">
			<span class="tit_area">
				<button type="button" @click="goBack()" class="btn">
					<i class="ico24_back"></i>
					<span class="txt_hidden">뒤로가기</span>
				</button>
			</span>
			<router-link :to="'/home'" tag="button" type="button" class="btn">
				<i class="ico24_home"></i>
				<span class="txt_hidden">홈</span>
			</router-link>
		</div>

		<!-- D layout -->
		<div v-if="type === 'D'" class="sub wrap search">
			<span class="tit_area">
				<button type="button" @click="goBack()" class="btn">
					<i class="ico24_back"></i>
					<span class="txt_hidden">뒤로가기</span>
				</button>
			</span>
			<h1 class="result">
				<span @click="$emit('titleClick', { title: headerTitle })">{{ headerTitle }}</span>
				<button type="button" class="btn_reset" @click="$emit('clearKeywordButtonClick')">
					<span class="txt_hidden">검색창 띄우기</span>
				</button>
			</h1>
			<span class="btn_area">
				<router-link to="/orderSend/cartSend" tag="button" type="button" class="btn">
					<i class="ico24_cart"></i>
					<span class="txt_hidden">장바구니</span>
					<em class="badge" v-if="badge">{{ badge }}</em>
				</router-link>
			</span>
		</div>

		<!-- E layout -->
		<div v-if="type === 'E'" class="sub wrap">
			<span class="tit_area">
				<button type="button" @click="goBack()" class="btn">
					<i class="ico24_back"></i>
					<span class="txt_hidden">뒤로가기</span>
				</button>
				<h1>{{ headerTitle }}</h1>
			</span>

			<span class="btn_area">
				<button type="button" class="btn" @click="$emit('searchButtonClick')">
					<i class="ico24_search"></i>
					<span class="txt_hidden">검색</span>
				</button>
				<router-link to="/home" class="btn" @click.native="onHomeButtonClick">
					<i class="ico24_home"></i>
					<span class="txt_hidden">홈</span>
				</router-link>
			</span>
		</div>

		<!-- F layout -->
		<div v-if="type === 'F'" class="sub wrap">
			<span class="tit_area">
				<button type="button" @click="goBack()" class="btn">
					<i class="ico24_back"></i>
					<span class="txt_hidden">뒤로가기</span>
				</button>
				<h1>{{ headerTitle }}</h1>
			</span>
		</div>
	</header>
</template>

<script>
import { computed, defineComponent, unref } from '@vue/composition-api';
import { useStore } from '@vueblocks/vue-use-vuex';
import { useRouter } from '@/utils/hooks';
import useCartListAPI from '@/api/hooks/useCartListAPI';
import HeaderLogo from '@/Layout/common/headerLogo';

export default defineComponent({
	name: 'headerLayout',
	props: {
		type: {
			type: String,
			default: 'A',
		},
	},
	components: {
		HeaderLogo,
	},

	setup() {
		const store = useStore();
		const router = useRouter();

		const cartListAPI = useCartListAPI();

		return {
			headerTitle: computed(() => store.getters.headerTitle),
			badge: computed(() => unref(cartListAPI.data)?.totalCount),
			goBack: () => router.go(-1),
			onHomeButtonClick: () => store.dispatch('home/clearSelectedInfo'),
		};
	},
});
</script>

<style lang="less" scoped>
.ly_header {
	overflow: hidden;
}
</style>
